<template>
    <vx-modal :title="$t('MODALS.originSelect.title')" width="35%">
        <template v-slot:body>
            <div class="search_question w-full flex px-3">
                <feather-icon icon="SearchIcon" />
                <input v-model="inputSearch" :placeholder="$t('MODALS.originSelect.searchPlaceHolder')" class="input_search p-3 w-full" type="text">
            </div>
            <div class="cursor-pointer overflow-y-auto" style="height: 460px;">
                <div class="Lista pt-2" v-for="(_item, index) in filterQuestions" :key="index" 
                    @click="selected(_item)?null:addRelated(_item)" 
                    :class="{'question-selected': selected(_item)}">

                    <div class="flex justify-between px-5 py-2">
                        <span><b>{{_item.type}} : </b>{{$t(`INPUTTYPE.${_item.type}.${_item.inputType}`)}}</span>
                        <span><b>Id: </b>{{_item.name}}</span>
                    </div>
                    <div class="w-full px-5 py-3">
                        {{_item.label}}
                    </div>
                </div>
            </div>
        </template>
    </vx-modal>
</template>
<script type="text/javascript">
import { mapState, mapMutations } from 'vuex';
import { getAllQuestion, setQuestion } from '../../indexDB/logic.js';
import { createDependenceListener, getListener } from '../../indexDB/dependencies.js';

import InputNumber from '../Number.vue';
export default {
    components: { InputNumber },
    data() {
        return {
            allQuestion: [],
            inputSearch: '',
            questions: [],
            AllQuestions: [],
            nameQuestionChild: ''
        }
    },
    mounted() {     
        this.getAllQuestions(); 
        this.recreate(); 
    },
    watch: {
        activePopup: function(value) {
            // if (!value) this.clearData();
        },     
    },
    methods: {
        ...mapMutations('resource', ['UPDATE_STATE']),
        async getAllQuestions() {
            await setQuestion();
            this.AllQuestions = await getAllQuestion();
            
            const name = this.questionsByPage[this.indexQuestion].name;
            const index = this.AllQuestions.findIndex(question => question.name === name);
            const slice = this.AllQuestions.slice(0, index);
            const filter = slice.filter(question => question.inputType === 'select')
                                .filter(question => question.query.action !== 'trigger');
            this.questions = filter.map(question => {
                delete question.help;
                delete question.properties;
                delete question.query;
                delete question.related;
                delete question.required;
                return question;

            });
        },
        async recreate() {
            const result = await getListener();
            const { listener } = result;
            if(listener[this.nameDad]) {
                this.nameQuestionChild = listener[this.nameDad].related.name;
            }
            
        },
        async addRelated(question) {            
            const index =  this.AllQuestions.findIndex(item => item.name === question.name);
            const related = {
                name: question.name,
                question:index,
                relatedness:"listener",
                answer:"n/a"
            }
            await createDependenceListener(this.nameDad, related);
            this.recreate();
        },
        selected(item) {
            console.log('item ',item)
            console.log('this.nameQuestionChild ',this.nameQuestionChild)
            return (this.nameQuestionChild === item.name);
        }
    },
    computed: {
        ...mapState('resource', ['listOrigins', 'indexQuestion', 'questionsByPage', 'activePopup']),       
        nameDad() {
            return this.questionsByPage[this.indexQuestion].name;
        },
        filterQuestions() {
            return this.questions.filter(question => {

                const condition_1 = question.name.toLowerCase().includes(this.inputSearch.trim().toLowerCase());
                const dondition_2 = question.label.toLowerCase().includes(this.inputSearch.trim().toLowerCase());
                return (condition_1 || dondition_2)
            });
        }

    }
}

</script>

<style type="text/css" lang="scss">   
    .search_question {
        border-bottom: 1px solid rgba(110, 110, 110, 0.2);
        .input_search {
            border:none;
        }
    }

    .Lista {
        border-bottom: 1px solid rgba(110, 110, 110, 0.2);
        &:hover{
            background: #E6E6E6;
        }
    }
    .question-selected {
        background: #E6E6E6;
    }

</style>
